import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrows,
  faCompressAlt,
  faExpandAlt,
  faTimes,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import { CHART_SIZE_LARGE, CHART_SIZE_DEFAULT } from '../../constants/common';

function ChartWindow({
  children,
  size = CHART_SIZE_DEFAULT,
  resizable = true,
  draggable = true,
  dark = false,
  handleClose,
  handleResize,
}) {
  return (
    <div className={`engineering-chart ${dark ? ' dark' : ''}`}>
      <div className="controls">
        {draggable && (
          <FontAwesomeIcon
            icon={faArrows}
            className="handle"
            title="Click to Drag Chart"
            aria-label="Drag chart"
            role="img"
          />
        )}
        <div className="btn-group btn-group-sm float-end">
          {resizable && (
            <button
              onClick={() => handleResize(size)}
              title="Toggle Graph Size"
              aria-label={size === CHART_SIZE_LARGE ? "Decrease chart size" : "Increase chart size"}
              className="btn btn-default"
            >
              <FontAwesomeIcon
                icon={size === CHART_SIZE_LARGE ? faCompressAlt : faExpandAlt}
              />
            </button>
          )}
          <button
            onClick={handleClose}
            title="Close Graph"
            aria-label="Close chart"
            className="btn btn-default"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      </div>
      {children}
    </div>
  );
}

export default ChartWindow;
